import { RichiestaModuloDTO } from '@framework/api-client';

/**
 * Ritorna vero se l'utente ha accesso a *tutti* i moduli della richiesta.
 *
 * L'endpoint dei moduli ritorna sempre l'intero elenco dei moduli, ma valorizza
 * `permessi` solo per quelli a cui l'utente corrente ha accesso (in coerenza con
 * le policy delle deleghe). Un delegato abilitato solo su alcuni moduli avrà
 * quindi `permessi` vuoti sui moduli non delegati.
 */
export function hasAccessToAllModules(modules: RichiestaModuloDTO[]) {
  return (
    modules.length > 0 &&
    modules.every(module => (module.permessi?.length ?? 0) > 0)
  );
}
